import { DropdownOption } from '../components/Dropdown/DropdownOption'

export const createDropdownOptionObject = <T,>({ labelText, value }: { labelText: string; value: T }) => {
  return {
    label: <DropdownOption title={labelText} variant={'stack'} />,
    value: value,
    inputLabel: <DropdownOption title={labelText} variant={'inline'} />,
    labelCopy: labelText,
  }
}
